import { ArrowUp } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

const LABELS = {
  cs: "Zpět nahoru",
  en: "Back to top",
  es: "Volver arriba",
};

export default function BackToTop({ align = "right", testId = "back-to-top" }) {
  const { locale } = useI18n();
  const label = LABELS[locale] || LABELS.cs;

  const onClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className={`flex ${align === "right" ? "justify-end" : "justify-start"}`}>
      <button
        type="button"
        onClick={onClick}
        data-testid={testId}
        aria-label={label}
        className="group inline-flex flex-col items-center gap-2.5 select-none"
      >
        <span
          className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-[#eeeae1] border border-[#e0d9c8] flex items-center justify-center transition-all duration-400 group-hover:bg-[#252525] group-hover:border-[#252525] group-hover:-translate-y-1"
        >
          <ArrowUp
            size={18}
            strokeWidth={1.5}
            className="text-[#4a4a45] transition-colors duration-400 group-hover:text-[#f9f8f5]"
          />
        </span>
        <span className="text-[10px] tracking-[0.24em] uppercase text-[#8a857b] group-hover:text-[#4a4a45] transition-colors duration-300">
          {label}
        </span>
      </button>
    </div>
  );
}
